import { instance } from "api/apiBase";
import { BulkImportStatus, ImportableLockbox } from "api/lockboxImport";

interface IgloohomeStatusResponse {
  connected: boolean;
}

interface IgloohomeAuthorizationUrlResponse {
  authorization_url: string;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/igloohome";

export const igloohomeApi = {
  getStatus: async (): Promise<IgloohomeStatusResponse> => {
    const { data } =
      await instance.get<IgloohomeStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  // The account isn't created until the OAuth callback exchanges a code for tokens.
  startConnect: async (
    name: string
  ): Promise<IgloohomeAuthorizationUrlResponse> => {
    const { data } = await instance.post<IgloohomeAuthorizationUrlResponse>(
      `${BASE_ENDPOINT_URL}/accounts`,
      { name }
    );
    return data;
  },

  getLockboxes: async (accountId: number): Promise<ImportableLockbox[]> => {
    const { data } = await instance.get<ImportableLockbox[]>(
      `${BASE_ENDPOINT_URL}/devices`,
      { params: { account_id: accountId } }
    );
    return data;
  },

  bulkImportLockboxes: async (
    accountId: number,
    serial_numbers: string[]
  ): Promise<void> => {
    await instance.post(`${BASE_ENDPOINT_URL}/devices/bulk_import`, {
      account_id: accountId,
      serial_numbers
    });
  },

  getBulkImportStatus: async (): Promise<BulkImportStatus> => {
    const { data } = await instance.get<BulkImportStatus>(
      `${BASE_ENDPOINT_URL}/devices/bulk_import_status`
    );
    return data;
  }
};
